import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { combineReducers } from "redux";
import authReducer from "./slices/authSlice";

import { configureStore } from "@reduxjs/toolkit";


// Combine reducers (in case you add more later)
const appReducer = combineReducers({
  auth: authReducer,


  // DashBoard End

  
});

// ================== RESET WRAPPER ==================

const rootReducer = (state, action) => {
  if (action.type === "RESET_STORE") {
    state = undefined; // 🔥 resets entire redux state
  }
  return appReducer(state, action);
};

// Persist config
const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "auth",

  ],
};

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure the store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Required for redux-persist
    }),
});

// Persistor
export const persistor = persistStore(store);
